module.exports = __webpack_public_path__ + "img/cards.e97f1d4f.png";